<script setup lang="ts">
import { useProgressBar } from '@/composables/useProgressBar'

const { active } = useProgressBar()
</script>

<template>
  <div
    class="fixed top-0 left-0 right-0 z-9999 h-0.75 pointer-events-none"
    :class="active ? 'opacity-100' : 'opacity-0'"
    style="transition: opacity 0.3s ease"
  >
    <div
      class="h-full"
      :class="active ? 'w-4/5' : 'w-full'"
      style="
        background: linear-gradient(90deg, var(--color-primary), var(--color-secondary));
        transition: width 10s cubic-bezier(0.1, 0.05, 0, 1), opacity 0.3s ease;
      "
    />
  </div>
</template>
